import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import UserProfile from './UserProfile'
import ScheduleNavbarDropdown from './ScheduleNavbarDropdown'
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Badge from 'react-bootstrap/Badge';
const GRADIENT_STYLES = [
  { key: 'sorbet', name: 'Sunset Sorbet' },
  { key: 'periwinkle', name: 'Periwinkle Mint' },
  { key: 'lavender', name: 'Lavender Peach' },
  { key: 'mint', name: 'Minty Lemonade' },
  { key: 'bubblegum', name: 'Bubblegum Sky' },
  { key: 'aurora', name: 'Aurora' },
  { key: 'honey', name: 'Honey Meadow' },
  { key: 'deep', name: 'Deep Periwinkle' }
];

function OrganizerNavBar(props) {
  const [theme, setTheme] = useState(window.localStorage.getItem('THEME') || 'light');
  const [gradientStyle, setGradientStyle] = useState(window.localStorage.getItem('GRADIENT_STYLE') || 'sorbet');

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
    window.localStorage.setItem('THEME', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-gradient', gradientStyle);
    window.localStorage.setItem('GRADIENT_STYLE', gradientStyle);
  }, [gradientStyle]);

  var onAlertClick = function(event){
 //   setSelectedItem(newschedule);
   props.onScheduleTypeChange("NOT_SCHEDULED")

  }
  

  return (
    <Navbar expand="lg" >
      <Container>
        <Navbar.Brand >
          <img
            alt=""
            src="TickMark192.png"
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{' '}
          Organizer
        </Navbar.Brand>
        
        <ScheduleNavbarDropdown currentSchedule={props.schedule} unscheduledItems={props.unscheduledItems} onScheduleTypeChange={props.onScheduleTypeChange}></ScheduleNavbarDropdown>
       
        <Nav className={props.unscheduledItems.length>0?"me-auto visible":"me-auto invisible"}>
        <Nav.Item name="NOT_SCHEDULED" onClick={onAlertClick} className="notification-bell" title="Unscheduled tasks">
          <i className="bi bi-bell-fill"></i>
          <Badge pill bg="warning" text="dark">{props.unscheduledItems.length}</Badge>
        </Nav.Item></Nav>
        {/*<Navbar.Toggle aria-controls="basic-navbar-nav" />*/}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
       
        <Nav.Item>
        <Nav className="me-auto">
          <Nav.Link href="/reports">Reports</Nav.Link>
          </Nav>
          </Nav.Item>
          <Nav className="me-auto">
            <UserProfile></UserProfile>
          </Nav>
          <Nav>
            <NavDropdown align="end" title={<i className="bi bi-palette" title="Change style"></i>} id="gradient-style-dropdown">
              {GRADIENT_STYLES.map(style =>
                <NavDropdown.Item key={style.key} active={gradientStyle === style.key} onClick={() => setGradientStyle(style.key)}>
                  <span className={"style-swatch style-swatch-" + style.key}></span>{style.name}
                </NavDropdown.Item>
              )}
            </NavDropdown>
            <Nav.Link onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')} title="Toggle dark mode">
              <i className={theme === 'light' ? 'bi bi-moon' : 'bi bi-sun'}></i>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

// eslint-disable-next-line no-unused-vars
function Search(props) {

  var onSearchChange = function(event){
    props.onSearchChange(event.target.value)
  }

  return(
    <Form inline>
        <InputGroup>
          <Form.Control onChange={onSearchChange}
            placeholder="Search"
            aria-label="taskType"
            aria-describedby="basic-addon1"
          />
        </InputGroup>
      </Form>
  )
}
export default OrganizerNavBar